import { createJSONRequest } from './create-request'

export const fetchNetworkContacts = () => createJSONRequest({
  method: 'GET',
  url: '/api/network-contacts',
})

export const fetchMyClaims = () => createJSONRequest({
  method: 'GET',
  url: '/api/network-contacts/my-claims',
})

export const addNetworkContact = (elasticId, { phone = null, notes = null, ownerActorId = null } = {}) => createJSONRequest({
  method: 'POST',
  url: '/api/network-contacts',
  data: { elastic_id: elasticId, phone, notes, owner_actor_id: ownerActorId },
})

export const transferNetworkContact = (elasticId, ownerActorId, duplicate = false) => createJSONRequest({
  method: 'POST',
  url: `/api/network-contacts/${elasticId}/transfer`,
  data: { owner_actor_id: ownerActorId, duplicate },
})

export const updateNetworkContact = (elasticId, { phone, notes, contributors_data }) => createJSONRequest({
  method: 'PUT',
  url: `/api/network-contacts/${elasticId}`,
  data: { phone, notes, contributors_data },
})

export const deleteNetworkContact = (elasticId) => createJSONRequest({
  method: 'DELETE',
  url: `/api/network-contacts/${elasticId}`,
})
